import { render, staticRenderFns } from "./xmgd.vue?vue&type=template&id=65fb1a77&scoped=true&"
import script from "./xmgd.vue?vue&type=script&lang=js&"
export * from "./xmgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb1a77",
  null
  
)

export default component.exports